import { registerCardMgmtRoutes } from './cardMgmtRoutes';

const registerRoutes = (server) => {
    registerCardMgmtRoutes(server);
};

export default registerRoutes;
